import { Box } from '@repo/ui/Box';
import { Layout } from '../../components/Layout/Layout';
import s from './MethodLayout.module.css';
import { Step } from '../../components/Step/Step';
import { NavigationHeader } from '../../components/NavigationHeader/NavigationHeader';
import { Page } from '../../components/Page/Page';

export const MethodLayout = () => (
  <Page>
    <NavigationHeader
      title={{
        langKey: `pdx.method.header`,
      }}
    />
    <Layout isFullWidth>
      <Box isContainer>
        <Step formId="MethodStepForm" className={s.layout} />
      </Box>
    </Layout>
  </Page>
);
